export default {
	singular_model_name_spanish: 'Estadistica',
	plural_model_name_spanish: 'Estadisticas',
	create_model_name_spanish: 'Nueva estadistica',
	text_delete: 'la',
}